class SearchForm {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const searchList = '.js-search-list';
    const searchItem = '.js-search-item';
    const inputItem = '.js-search-input';
    const inputTtl = '.js-search-ttl';
    $(inputTtl).on('click',function(){
      const item = $(this).next(searchList);      

      $(".js-search-list").not(item).fadeOut(100, function () {});
      $(".js-search-list").not(item).removeClass('is-active');

      if(item.hasClass('is-active')) {
        item.removeClass('is-active');
        item.fadeOut(100, function () {
        });
      }else{
        item.addClass('is-active');
        item.fadeIn(100, function () {
        });
      }
    })

    $(searchItem).on('click',function(){
      $(this).parents(searchList).fadeToggle(100);
    })
    $(searchItem).on('click',function(){
      let dataName = $(this).data('name');
      let dataId = $(this).data('id');
      let dataText = $(this).text();
      $(inputItem+'[name='+dataName+']').val(dataId);
      $(inputTtl+'[data-name='+dataName+']').find('span').text(dataText);
    })

    // スマホ検索
    const spSearchToggle = '.js-sp-search-toggle';
    const spSearchWrap = '.js-sp-search-wrap';
    const spSearchBg = '.js-sp-search-bg';
    const spSearchClose = '.js-sp-search-close';

    $(spSearchToggle).on('click',function(){
      $(spSearchWrap).fadeIn();
      $(spSearchBg).fadeIn();
    })
    $(spSearchBg).on('click',function(){
      $(spSearchWrap).fadeOut();
      $(spSearchBg).fadeOut();
    })
    $(spSearchClose).on('click',function(){
      $(spSearchWrap).fadeOut();
      $(spSearchBg).fadeOut();
    })
  }
}
